import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Browser } from "@capacitor/browser";
import { isAndroidApp, mobileAuthReturnUrl } from "@/lib/nativePlatform";
import { AUTH_RETURN_KEY, safeReturnPath } from "@/lib/authNavigation";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshUser = useCallback(async () => {
    try {
      const response = await fetch(`${API}/auth/me`, { credentials: "include" });
      if (response.status === 204) { setUser(null); return; }
      if (!response.ok) throw new Error("Not signed in");
      setUser(await response.json());
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    refreshUser();
  }, [refreshUser]);

  const login = useCallback(async (returnPath = window.location.pathname) => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const targetPath = safeReturnPath(typeof returnPath === "string" ? returnPath : window.location.pathname);
    localStorage.setItem(AUTH_RETURN_KEY,targetPath);
    const redirectUrl = isAndroidApp() ? mobileAuthReturnUrl : window.location.origin + targetPath;
    const authUrl = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    if (isAndroidApp()) await Browser.open({ url: authUrl });
    else window.location.href = authUrl;
  }, []);
  const logout = useCallback(async () => { const response=await fetch(`${API}/auth/logout`,{method:"POST",credentials:"include",headers:{"X-ShaneAI-Request":"logout"}});if(!response.ok)throw new Error("Sign out could not be completed");setUser(null); }, []);
  const value = useMemo(() => ({ user, loading, login, logout, refreshUser, setUser }), [user, loading, login, logout, refreshUser]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);